import { render } from "./ValidateUserPage.vue?vue&type=template&id=6cfedd73&scoped=true&ts=true"
import script from "./ValidateUserPage.ts?vue&type=script&lang=ts"
export * from "./ValidateUserPage.ts?vue&type=script&lang=ts"

import "./ValidateUserPage.vue?vue&type=style&index=0&id=6cfedd73&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfedd73"]])

export default __exports__